import React, { useState, useMemo, useEffect }  from 'react';
import HtmlEditor, { Toolbar, Item } from 'devextreme-react/html-editor';
import { SingleCollapse } from "@/components/";
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import styles from './index.module.scss';
import { Enums, Utilities } from "@utils";

export interface IReportFieldProps{    
	data: any;
	periods: any;
	question: string;
	maxLength: number;
	disabled: boolean;
	createdByLabel: string;
	noHistoryLabel: string;
	year: string;
	historyTourData?: any;
}

const ReportField: React.FC<IReportFieldProps> = ({data, periods, question, maxLength, disabled, createdByLabel, noHistoryLabel, year, historyTourData}: IReportFieldProps) => {
    const [currentData, setCurrentData] = useState(data.current);
    const [historyData, setHistoryData] = useState(data.history);
    const [counter, setCounter] = useState(Utilities.plainCount(currentData));

	const view: IFollowupSubproject = {
        state: {
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

	useEffect(() => {
		setCurrentData(data.current)
		setCounter(Utilities.plainCount(data.current))
	}, [data.current])
	
	useEffect(() => {
		setHistoryData(data.history)
	}, [data.history])

    const renderToolbar = useMemo(() => (
        <Toolbar>
            <Item formatName="undo" />
            <Item formatName="redo" />
            <Item formatName="separator" />
            <Item formatName = "size" formatValues={['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']}/>
            <Item formatName="font" formatValues={['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']}/>
            <Item formatName="separator" />
            <Item formatName="bold" />
            <Item formatName="italic" />
            <Item formatName="strike" />
            <Item formatName="underline" />
            <Item formatName="separator" />
            <Item formatName="alignLeft" />
            <Item formatName="alignCenter" />
            <Item formatName="alignRight" />
            <Item formatName="alignJustify" />
            <Item formatName="separator" />
            <Item formatName="orderedList" />
            <Item formatName="bulletList" />
            <Item formatName="separator" />
            <Item formatName="color" />
            <Item formatName="background" />
            <Item formatName="separator" />
          </Toolbar>  
    ), [])

    const renderEditorHistory = (history:any) => {
		if(history?.length > 0 && periods?.length){
			let inPeriods = presenter.formMasters.inPeriods?.filter((x: any) => x.Anio === year) || []
			return inPeriods.map((item: any, idx: number) => {
				let actualPeriod = periods.filter((x: any) => x.SeguimientoPeriodosId === item.Id)
				return (
					<SingleCollapse key={item.Id} title={item.Title} sub={true} isOpen={presenter.stepTourIN === 5 ? true : false}> 
						{
							actualPeriod.map((x: any, i: number) =>{
								if(!!historyTourData){
									return (
										<div key={i} id={question === Enums.NarrativeReportFields.DesviacionesExplicacion ? 'NarrativeRepTourStep5' : ''}>
											{
												(idx === 0) ?
												<>
													<div>
														<h6>{createdByLabel}: {presenter.currentUser?.currentUser?.displayName || ""}</h6>
													</div>
													<div>
														<p dangerouslySetInnerHTML={{ __html: historyTourData }}></p>
													</div>
												</>
												: 	<div>{noHistoryLabel}</div>
											}
											
										</div>
									)
								}else{
									let report = history.find((y: any) => y.ReportePeriodoId === x?.Id)
									return (
										<div key={i} >
											{
												report ?
													<>
														<div>
															<h6>{createdByLabel}: {report?.PProaModifiedBy?.Title || ""}</h6>
														</div>
														<div>
															<p dangerouslySetInnerHTML={{ __html: report?.[question] }}></p>
														</div>
													</>
												: <div>{noHistoryLabel}</div>
											}
											
										</div>
									)
								}
							})
						}
					</SingleCollapse>
				)
			})
		}else{
			return <div>{noHistoryLabel}</div>
		}
    }
    
    const renderEditorMaster = (current:any, history:any) => { 
		const valueChanged = (e: any) => {
				const count = Utilities.plainCount(e.value)
				if (count <= maxLength){
					setCurrentData(e.value)
					setCounter(count);
				}
		}

		const editor:any = {
			height: 300,
			disabled: disabled
		};

		if(!Utilities.isNullObject(current)){
			editor.id = question;
		}
		
		return (
			<>
				<div style={{display:"flex", justifyContent:"flex-end", alignItems:"center"}}>          
					<label style={{paddingRight:"1rem", color:"rgb(150,150,150)"}}>{counter}/{maxLength}</label>
				</div>
				<div className={styles.textContainer} id={(question === Enums.NarrativeReportFields.DesviacionesExplicacion) ? 'NarrativeRepTourStep4' : ''}>
					<HtmlEditor 
						{...editor}
						value={currentData}
						onValueChanged={valueChanged}
					>
						{renderToolbar}
					</HtmlEditor>
				</div>
				<div className={styles.historyContainer}>         
					{renderEditorHistory(history)}          
				</div>
			</>
		)
    }   
    return renderEditorMaster(currentData, historyData)
}

export default ReportField;